import {z} from 'zod';

export const workshopServiceOrderGroupDetailFormSchema = z.object({
  name: z.string(),
  code: z.string().nullish(),
  validityFrom: z.date().nullish(),
  validityTo: z.date().nullish(),
  authorizationProfileIds: z.array(z.string()).nullish(),
  serviceOrderTypeIds: z.array(z.string()).nullish(),
  serviceOrderVariantIds: z.array(z.string()).nullish(),
});

export type WorkshopServiceOrderGroupDetailFormType = z.infer<
  typeof workshopServiceOrderGroupDetailFormSchema
>;
